export default {
  "home.hero.title": "草榴二维码最新入口",
  "home.hero.subtitle": "快速获取草榴社区最新二维码，轻松扫码进入",
  "home.hero.cta": "查看最新入口",
  "home.hero.secondary": "了解更多",

  "home.latest.title": "最新草榴二维码入口",
  "home.latest.subtitle": "实时更新，确保您随时找到可用入口",
  "home.latest.updatedAt": "更新时间",
  "home.latest.copyLink": "复制链接",
  "home.latest.scanGuide": "扫码指南",

  "home.categories.title": "内容分类导航",
  "home.categories.subtitle": "按类别查找您需要的信息",
  "home.categories.articleCount": "篇文章",

  "home.articles.title": "精选文章推荐",
  "home.articles.subtitle": "精心整理的草榴社区使用指南与技巧",
  "home.articles.readTime": "分钟阅读",

  "home.faq.title": "常见问题解答",
  "home.faq.subtitle": "关于草榴二维码的常见疑问，这里都有答案",
  "home.faq.stillQuestions": "还有其他问题？",

  "home.cta.title": "找不到最新入口？",
  "home.cta.subtitle": "收藏本站，我们将持续更新草榴社区最新二维码入口信息，让您不再迷路。",
  "home.cta.button": "立即收藏本站",
  "home.cta.secondary": "查看使用教程",
}